import { ChangelogEntry } from '../types';
import { CloudPill } from './CloudPill';
import { regionsWithTiers } from '../lib/models';

const MAX_ENTRIES = 8;

function fmtDate(iso: string) {
  return new Date(iso).toLocaleDateString(undefined, { dateStyle: 'medium' });
}

export function WhatsNew({ entries }: { entries: ChangelogEntry[] }) {
  if (entries.length === 0) return null;
  return (
    <details className="whatsnew">
      <summary>
        What&rsquo;s new
        <span className="whatsnew-hint">availability changes spotted by the daily refresh</span>
      </summary>
      <div className="whatsnew-body">
        {entries.slice(0, MAX_ENTRIES).map(e => (
          <div key={`${e.cloud}-${e.date}`} className="whatsnew-entry">
            <div className="whatsnew-date">
              {fmtDate(e.date)}
              <CloudPill cloud={e.cloud} />
            </div>
            <ul>
              {(e.addedModels ?? []).map(m => (
                <li key={`a-${m.modelId}`}>
                  <span className="badge whatsnew-added">new</span>
                  {' '}{m.modelName}{m.providerName ? ` (${m.providerName})` : ''}
                  {m.regions?.length ? <span className="whatsnew-regions"> — {regionsWithTiers(m.regions, m.regionTiers)}</span> : null}
                </li>
              ))}
              {(e.regionAdditions ?? []).map(m => (
                <li key={`r-${m.modelId}`}>
                  <span className="badge whatsnew-expanded">expanded</span>
                  {' '}{m.modelName}
                  {m.regions?.length ? <span className="whatsnew-regions"> — now in {regionsWithTiers(m.regions, m.regionTiers)}</span> : null}
                </li>
              ))}
              {(e.statusChanges ?? []).flatMap(m => [
                m.toLegacy?.length ? (
                  <li key={`sl-${m.modelId}`}>
                    <span className="badge whatsnew-legacy">legacy</span>
                    {' '}{m.modelName}
                    <span className="whatsnew-regions"> — now legacy in {m.toLegacy.join(', ')}</span>
                  </li>
                ) : null,
                m.toActive?.length ? (
                  <li key={`sa-${m.modelId}`}>
                    <span className="badge whatsnew-expanded">reactivated</span>
                    {' '}{m.modelName}
                    <span className="whatsnew-regions"> — active again in {m.toActive.join(', ')}</span>
                  </li>
                ) : null,
              ])}
              {(e.removedModels ?? []).map(m => (
                <li key={`d-${m.modelId}`}>
                  <span className="badge whatsnew-removed">removed</span>
                  {' '}{m.modelName}{m.providerName ? ` (${m.providerName})` : ''}
                  {m.regions?.length ? <span className="whatsnew-regions"> — {regionsWithTiers(m.regions, m.regionTiers)}</span> : null}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </details>
  );
}
